import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton de React Query compartido por toda la app. Vive en su propio módulo
 * —y no dentro de App.tsx— para que utilidades no-React (p. ej. el teardown de
 * sesión) puedan limpiar su caché en los cambios de identidad sin importar App
 * ni crear un ciclo de imports.
 *
 * Ojo con la caché: las queries usan queryKeys estáticas (p. ej. el perfil vive
 * bajo ['bootstrap','profile']) compartidas por TODOS los usuarios, y con
 * staleTime de 1 min. Si no se limpia al cambiar de identidad, el usuario nuevo
 * ve los datos cacheados del anterior. Por eso se llama queryClient.clear() en
 * cada login/logout (ver shared/auth/session).
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60,
			refetchOnWindowFocus: true,
			retry: 1,
		},
	},
});
